export const brandFromCustomerID = (customerID?: string | undefined | null) => {
  return "leafdoctors";
};
